import * as THREE from 'three'
import * as RAPIER from '@dimforge/rapier3d-compat'
import { Engine } from '@core/Engine'
import { GameObject } from '@ecs/GameObject'
import { MeshRenderer } from '@components/Graphics/MeshRenderer'
import { Camera } from '@components/Graphics/Camera'
import { PlayerController } from '@components/PlayerController'
import { DirectionalLight } from '@components/Graphics/DirectionalLight'
import { Collider } from '@components/Physics/Collider'
//import { CubeSpawner } from '@game/components/CubeSpawner'
import { TransformData } from '@components/Transform'
import { TextRenderer3D } from '@components/Graphics/TextRenderer3D'
import { Joint } from '@components/Physics/Joint'
import { RigidBody } from '@components/Physics/RigidBody'
import { ProjectNavigator, ProjectPresentation } from './components/ProjectNavigator'
import { ControllerSpawner } from '@components/ControllerSpawner'
import { CarController } from './components/CarController'
import { SpectatorController } from './components/SpectatorController'
import { cubemapPaths } from './ShadertoyIntegration/shadertoyCanvas'



export class World extends Engine {
  //fps: GameObject
  maincolor = 0X87CEEB
  secondcolor = 0Xffa500
  constructor() {
    super()
    console.log('world created')
    console.log('Bienvenu sur le portfolio de Adam Ait Boukha')

    this.time.fixedDelta = 1 / 60
    this.scene.physicsDebug.enabled = false

    this.renderer.setClearColor(this.maincolor)
    this.scene.threeScene.add(new THREE.AmbientLight(0xffffff, 1))

    const camera = new GameObject(this, 'Camera', { position: new THREE.Vector3(0, 3, 10) })
    camera.addComponent(Camera, { fov: 75, near: 0.1, far: 1000 })
    camera.addComponent(PlayerController)
    //camera.addComponent(MeshRenderer, { geometry: new THREE.BoxGeometry(0.5, 0.5, 0.5), material: new THREE.MeshStandardMaterial({ color: 'white' }) })
    camera.addComponent(Collider, { colliderDesc: RAPIER.ColliderDesc.ball(0.5) })

    let spectatorSpawner = camera.addComponent(ControllerSpawner, { controllerClass: SpectatorController, buildData: {} })

    this.scene.add(camera)

    const navigator = camera.addComponent(ProjectNavigator, { name: "Accueil" })

    const homeViewPoint = new GameObject(this, 'HomeViewPoint', { position: new THREE.Vector3(10, 20, 30), rotation: new THREE.Euler(0, 0, 0) })
    homeViewPoint.transform.lookAt(new THREE.Vector3(0, 0, 0))
    navigator.addProject(new ProjectPresentation('Accueil', `
      Bienvenue sur mon portfolio interactif 3D !</br>
      Explorez mes projets en utilisant le menu de navigation.</br>
      Certains projets permettent d'être interactifs et d'ouvrir de nouvelles fenêtres.</br>
      Vous pouvez utiliser la touche T pour afficher ou cacher les indicateurs de debuggage.</br>
      Ce portfolio n'as malheureusement pas encore été terminé à temps pour ce pourquoi il a été réalisé (mon entretien d'admission aux études supérieures).<br>
      
      <br>
      <br>
      
      Etudiant de Terminale générale avec spécialités Mathématiques et Sciences de l'ingénieure.<br>
      
      <a style = "color: lightblue; text-decoration: underline;pointer-events: auto;" href="/resources/documents/CV_Adam_Ait_Boukha.pdf" target="_blank">CV</a><br><br>
      Adam Ait Boukha.<br>
      `, '', spectatorSpawner, '', homeViewPoint.transform))

    const light = new GameObject(this, 'DirectionalLight', { position: new THREE.Vector3(5, 20, 5) })
    light.addComponent(DirectionalLight, { target: this.scene.mainCamera?.graphicCamera, shadowMapSize: 1024 * 2, shadowRadius: 2 })

    this.scene.add(light)

    const floor = new GameObject(this, 'Floor', { position: new THREE.Vector3(0, -50, 0), scale: new THREE.Vector3(2000, 100, 2000) })
    floor.addComponent(MeshRenderer, { geometry: new THREE.BoxGeometry(1, 1, 1), material: new THREE.MeshStandardMaterial({ color: this.maincolor }) })
    floor.addComponent(Collider, {})
    this.scene.add(floor)
    // // build a pool
    // const s = 5
    // const h = 5
    // const e = 0.5
    // const walls = [
    //   new GameObject(this, 'LeftWall', { position: new THREE.Vector3(-s / 2, 0, 0), scale: new THREE.Vector3(e, h, s) }),
    //   new GameObject(this, 'RightWall', { position: new THREE.Vector3(s / 2, 0, 0), scale: new THREE.Vector3(e, h, s) }),
    //   new GameObject(this, 'BackWall', { position: new THREE.Vector3(0, 0, -s / 2), scale: new THREE.Vector3(s, h, e) }),
    //   new GameObject(this, 'FrontWall', { position: new THREE.Vector3(0, 0, s / 2), scale: new THREE.Vector3(s, h, e) }),
    // ]
    // for (const wall of walls) {
    //   wall.addComponent(MeshRenderer, { geometry: new THREE.BoxGeometry(1, 1, 1), material: new THREE.MeshStandardMaterial({ color: 'grey' }) })
    //   wall.addComponent(Collider, {})
    //   this.scene.add(wall, floor)
    // }


    //P5js Projects Area

    let p5jsBackground = new GameObject(this, 'P5jsBackground', { position: new THREE.Vector3(15, 5, 0), scale: new THREE.Vector3(8, 8, 1) })
    p5jsBackground.addComponent(MeshRenderer, { geometry: new THREE.BoxGeometry(1, 1, 1), material: new THREE.MeshStandardMaterial({ color: 0xed225d }) })
    p5jsBackground.addComponent(Collider, {})
    p5jsBackground.addComponent(RigidBody, { bodyDesc: RAPIER.RigidBodyDesc.dynamic() })
    this.scene.add(p5jsBackground, floor)
    let p5jsStatue = new GameObject(this, 'P5jsStatue', { position: p5jsBackground.transform.position.clone().sub(new THREE.Vector3(3, 1.5, -0.5)), scale: new THREE.Vector3(3, 3, 3) })
    p5jsStatue.addComponent(TextRenderer3D, { text: 'p5*' })
    p5jsStatue.transform.attachToParent = true
    this.scene.add(p5jsStatue, p5jsBackground)
    p5jsBackground.getComponent(Collider)?.collision.setMass(1000)

    let p5jsViewPoint = new GameObject(this, 'P5jsViewPoint', { position: p5jsBackground.transform.position.clone().add(new THREE.Vector3(0, 0, 15)), rotation: new THREE.Euler(0, 0, 0) })
    p5jsViewPoint.transform.attachToParent = true
    this.scene.add(p5jsViewPoint, p5jsBackground)

    const p5jsNavigatorSpawner = camera.addComponent(ControllerSpawner, { controllerClass: ProjectNavigator, name: "Projets P5js" })
    p5jsNavigatorSpawner.addBuildQueueListener((navigator) => {
      // const p5jsUrls = [
      //   "https://editor.p5js.org/Adam.abk/full/yOEzU_tEx", "https://editor.p5js.org/Adam.abk/full/RXb7s8PRT",
      //   "https://editor.p5js.org/Adam.abk/full/cNxcrx6-l", "https://editor.p5js.org/Adam.abk/full/-rc6SEs6x",
      //   "https://editor.p5js.org/Adam.abk/full/8kGV4-CO1", "https://editor.p5js.org/Adam.abk/full/2DntU1kl_"]
      const p5jsPresentations = [
        new ProjectPresentation(
          'Générateur de labyrinte',
          `Petit, un de mes passe temps préferé était de dessiner des labyrinthe carré sur des feuilles à carreaux, plus tard j'ai eu l'occasion de programmer un générateur de labyrinthe. son algorithme de génération commence par créer une grille pleine de murs, puis il détruit des murs aléatoirement en s'assurant de ne pas créer de boucles jusqu'à ce que chaque cellule soit accessible depuis n'importe quelle autre cellule. Pour le résolution, il fait couler de l'eau de l'entrée jusqu'à la sortie. Puis il remonte le chemin le plus court de la sortie à l'entrée.`,
          "https://editor.p5js.org/Adam.abk/sketches/yOEzU_tEx",
          undefined, '', p5jsViewPoint.transform).GenerateP5jsOverlay("https://editor.p5js.org/Adam.abk/full/yOEzU_tEx"),
        new ProjectPresentation(
          'Décomposition en triangles',
          `Un algorithme de triangulation de polygone simple en P5.js. Il détermine les triangles potentiels un par un puis apres en avoir trouvé un, il le retire du polygone et recommence jusqu'à ce qu'il n'y ait plus de polygone. Il ne gère pas les polygones avec des trous ni les polygones auto-intersectants. Il peut être utilisé pour du rendu 2D ou pour de la physique.<br><br>
          <h3>Controles :</h3><br>
          Clic gauche proche d'un point : déplacer le point<br>
          Clic gauche proche d'une arête : ajouter des points<br><br>

          <h3>Attention :</h3><br>
          Ne pas créer de polygone auto-intersectant ou inversé
          
          `,
          "https://editor.p5js.org/Adam.abk/sketches/RXb7s8PRT",
          undefined, '', p5jsViewPoint.transform).GenerateP5jsOverlay("https://editor.p5js.org/Adam.abk/full/RXb7s8PRT"),
        new ProjectPresentation(
          'Physique de balles',
          `Une simulation simple de balles avec gestion des collisions entre elles et avec les parois. Chaque balle est affectée par la gravité et perd son énergie à chaque rebond. Le code utilise des cercles pour représenter les balles et les parois.<br><br>
          <h3>Controles :</h3><br>
          Clic gauche : ajouter des balles<br>
          m : mélanger les balles<br>
          r : changer le rayon de la paroi<br>
          c : changer le point d'apparition des balles
          `,
          "https://editor.p5js.org/Adam.abk/sketches/cNxcrx6-l",
          undefined, '', p5jsViewPoint.transform).GenerateP5jsOverlay("https://editor.p5js.org/Adam.abk/full/cNxcrx6-l"),
        new ProjectPresentation(
          'Génerateur de G-code',
          `Ce projet est conçut pour génerer des dessins en G-code, le but est d'attacher un stylo sur la tete d'une imprimante 3D et de lui faire dessiner des images. <br>
          On peut charger un fichier .obj qui devra contenir des lignes (pas de faces) représentant le dessin à faire sur une zone entre x et y compris entre (-1,-1) et (1,1). Le code analyse les lignes et génère un G-code optimisé pour minimiser les déplacements à vide. <br>
          Voici quelques exemples de dessins réalisés avec ce générateur : <br><br>
          <div style="width:100%;display:flex;">
          <img src="/resources/textures/gcodeGenerator/gravure.jpg" style="width: 33%" />
          <div style="width: 33%;display:flex;flex-direction:column;">
            <img src="/resources/textures/gcodeGenerator/voiture.jpg" />
            <img src="/resources/textures/gcodeGenerator/poeme.jpg" />
          </div>
          <img src="/resources/textures/gcodeGenerator/geometryNodes.jpg" style="width: 35%"/>
          </div>
          `,
          "https://editor.p5js.org/Adam.abk/sketches/-rc6SEs6x",
          undefined, '', p5jsViewPoint.transform).GenerateP5jsOverlay("https://editor.p5js.org/Adam.abk/full/-rc6SEs6x"),
        new ProjectPresentation(
          'Marching Squares',
          `Une implémentation de l'algorithme Marching Squares en P5.js. L'algorithme génère des contours lisses à partir d'une grille de valeurs scalaires, souvent utilisée pour la visualisation de données ou la génération de terrains. Dans ce projet, nous pouvons dessiner des formes en temps réel et voir comment l'algorithme crée les contours correspondants.</br><br>
          <h3>Controles :</h3><br>
          Clic gauche : dessiner des formes<br>
          Shift + Clic gauche : effacer des formes<br>`,
          "https://editor.p5js.org/Adam.abk/sketches/8kGV4-CO1",
          undefined, '', p5jsViewPoint.transform).GenerateP5jsOverlay("https://editor.p5js.org/Adam.abk/full/8kGV4-CO1"),
        new ProjectPresentation(
          'Simulateur de particules',
          `Un simulateur de particules simple en P5.js. Les particules sont affectées par la gravité et interagissent entre elles avec des forces d'attraction et de répulsion. Le code utilise des cercles pour représenter les particules et permet d'ajouter ou de supprimer des particules en temps réel.<br><br>
          <h3>Controles :</h3><br>
          Clic gauche : ajouter des particules<br>
          r : réinitialiser les particules<br>
          Shift : afficher les vecteurs de vitesse et d'accélération
          `,
          "https://editor.p5js.org/Adam.abk/sketches/2DntU1kl_",
          undefined, '', p5jsViewPoint.transform).GenerateP5jsOverlay("https://editor.p5js.org/Adam.abk/full/2DntU1kl_"),
      ]
      for (const p5jsProject of p5jsPresentations) {
        (navigator as ProjectNavigator).addProject(p5jsProject)
      }
    })

    navigator.addProject(new ProjectPresentation('Projets P5.js', "Des microprojets qui utilisent la librairie P5.js, la plus grande partie sont des experiences ou des testes qui ne méritaient pas une vraie application, ce qui me permet aujourd'hui de les intégrer facilement à mon portfolio.", 'https://editor.p5js.org/Adam.abk/sketches', p5jsNavigatorSpawner, '', p5jsViewPoint.transform))
    //build a pile of boxes
    function buildBoxPile(world: World, floor: GameObject, s: number, transformData: TransformData) {
      for (let y = 0; y < s; y++) {
        for (let x = 0; x < s - y; x++) {
          const box = new GameObject(world, 'Box', { position: new THREE.Vector3(x + y / 2 - s / 2, y + 0.5, 0), scale: new THREE.Vector3(1, 1, 1).multiplyScalar(0.95) })
          box.addComponent(MeshRenderer, { geometry: new THREE.BoxGeometry(1, 1, 1), material: new THREE.MeshStandardMaterial({ color: world.secondcolor }) })
          box.addComponent(Collider, {})
          box.addComponent(RigidBody)
          box.transform.transformData = box.transform.transformData.TransformLocalToWorld(transformData)
          world.scene.add(box, floor)
        }
      }
    }

    buildBoxPile(this, floor, 10, new TransformData(undefined, undefined, new THREE.Vector3(1, 1, 1).multiplyScalar(1)))


    // const spawner = new GameObject(this, 'Box', { position: new THREE.Vector3(0, 15, 0), rotation: new THREE.Euler(Math.PI / 6, 0, 0), scale: new THREE.Vector3(1, 1, 1).multiplyScalar(0.25) })
    // spawner.addComponent(CubeSpawner, {});
    // this.scene.add(spawner)
    // console.dir(spawner.scene)


    // //add a fps counter object
    // this.fps = new GameObject(this, 'fps', { position: new THREE.Vector3(0, 20, 0) })
    // this.fps.userData = { fpsBuffer: 0 }
    // this.fps.addComponent(TextRenderer3D, { text: 'fps: 0' })
    // this.scene.add(this.fps)

    //Build a pickup car
    const car = new GameObject(this, 'Car', { position: new THREE.Vector3(0, 5, 7), scale: new THREE.Vector3(1, 1, 1).multiplyScalar(2) })
    car.addComponent(MeshRenderer, {
      geometryPath: '/resources/models/pickup.obj',
      geometry: new THREE.BoxGeometry(1, 1, 1),
      renderTransform: new TransformData(new THREE.Vector3(0.3, 0, 0), undefined, new THREE.Vector3(1, 1, 1).multiplyScalar(0.5)),
      material: new THREE.MeshStandardMaterial({ color: this.secondcolor })
    })
    car.addComponent(Collider, { colliderDesc: RAPIER.ColliderDesc.cuboid(1.9, 1.5, 2).setFriction(0.1).setMass(10).setTranslation(0.6, 0.5, 0), collisionGroup: "car" })
    const rbDesc = RAPIER.RigidBodyDesc.dynamic()
    car.addComponent(RigidBody, { bodyDesc: rbDesc })
    car.addComponent(Collider, { colliderDesc: RAPIER.ColliderDesc.cuboid(2, 0.75, 2).setFriction(0.1).setMass(10).setTranslation(-3.2, -0.25, 0), collisionGroup: "car" })
    car.addComponent(Collider, { colliderDesc: RAPIER.ColliderDesc.cuboid(1.15, 0.75, 2).setFriction(0.1).setMass(1).setTranslation(-1.5, 0.65, 0).setRotation(new THREE.Quaternion().setFromAxisAngle(new THREE.Vector3(0, 0, 1), Math.PI / 4)), collisionGroup: "car" })
    car.addComponent(Collider, { colliderDesc: RAPIER.ColliderDesc.cuboid(1.8, 0.4, 1.95).setFriction(1).setMass(1).setTranslation(4.5, -0.6, 0), collisionGroup: "car" })
    car.addComponent(Collider, { colliderDesc: RAPIER.ColliderDesc.cuboid(0.15, 0.8, 1.95).setFriction(1).setMass(1).setTranslation(4.5 - 1.825, 0, 0), collisionGroup: "car" })
    car.addComponent(Collider, { colliderDesc: RAPIER.ColliderDesc.cuboid(0.15, 0.8, 1.95).setFriction(1).setMass(1).setTranslation(4.5 + 1.7, 0, 0), collisionGroup: "car" })
    car.addComponent(Collider, { colliderDesc: RAPIER.ColliderDesc.cuboid(1.8, 0.8, 0.2).setFriction(1).setMass(1).setTranslation(4.5, 0, 1.75), collisionGroup: "car" })
    car.addComponent(Collider, { colliderDesc: RAPIER.ColliderDesc.cuboid(1.8, 0.8, 0.2).setFriction(1).setMass(1).setTranslation(4.5, 0, -1.75), collisionGroup: "car" })
    car.addComponent(Collider, { colliderDesc: RAPIER.ColliderDesc.cylinder(0.4, 0.85).setFriction(1).setMass(1).setTranslation(3.5, -0.5, -1.15).setRotation(new THREE.Quaternion().setFromAxisAngle(new THREE.Vector3(1, 0, 0), Math.PI / 2)), collisionGroup: "car" })
    car.addComponent(Collider, { colliderDesc: RAPIER.ColliderDesc.cylinder(0.4, 0.85).setFriction(1).setMass(1).setTranslation(3.5, -0.5, 1.15).setRotation(new THREE.Quaternion().setFromAxisAngle(new THREE.Vector3(1, 0, 0), Math.PI / 2)), collisionGroup: "car" })


    buildBoxPile(this, floor, 6, new TransformData(new THREE.Vector3(5, 2, 0), undefined, new THREE.Vector3(1, 1, 1).multiplyScalar(0.5)).TransformLocalToWorld(car.transform.transformData.clone().setScale(new THREE.Vector3(1, 1, 1))))


    car.addComponent(ControllerSpawner, { controllerClass: CarController, name: "Pickup" })

    car.addTag('car')
    this.scene.add(car)

    // add attached gameobject to have a correct viexpoint on project navigator
    const carViewPoint = new GameObject(this, 'CarViewPoint', { position: car.transform.position.clone().add(new THREE.Vector3(0, 2, 10)), rotation: new THREE.Euler(0, 0, 0) })
    carViewPoint.transform.attachToParent = true
    this.scene.add(carViewPoint, car)


    const WheelDistX = 3.5
    const WheelDistY = 2
    const WheelHeight = -1.5
    const WheelRadius = 1
    const WheelPositions = [{ x: WheelDistX, y: WheelHeight, z: WheelDistY }, { x: WheelDistX, y: WheelHeight, z: -WheelDistY }, { x: -WheelDistX, y: WheelHeight, z: WheelDistY }, { x: -WheelDistX, y: WheelHeight, z: -WheelDistY }]

    for (let i = 0; i < 4; i++) {
      const damper = new GameObject(this, 'Damper', { position: car.transform.position.clone().add(WheelPositions[i]), scale: new THREE.Vector3(1, 1, 1) })
      damper.addTag('damper')
      damper.addComponent(RigidBody, { bodyDesc: RAPIER.RigidBodyDesc.dynamic() })
      damper.addComponent(Collider, { colliderDesc: RAPIER.ColliderDesc.ball(0.7), collisionGroup: "ghost" })
      const damperJointDesc = RAPIER.JointData.prismatic(WheelPositions[i], { x: 0, y: 0, z: 0 }, { x: 0, y: 1, z: 0 })
      damper.addComponent(Joint, { params: damperJointDesc, body1: car.getComponent(RigidBody), body2: damper.getComponent(RigidBody) })
      const jointDesc2 = RAPIER.JointData.spring(0, 300, 150, WheelPositions[i], { x: 0, y: 0, z: 0 })
      damper.userData = { springJoint: damper.addComponent(Joint, { params: jointDesc2, body1: car.getComponent(RigidBody), body2: damper.getComponent(RigidBody) }) }

      this.scene.add(damper, car)

      const controlAxis = new GameObject(this, 'ControlAxis', { position: car.transform.position.clone().add(WheelPositions[i]), scale: new THREE.Vector3(1, 1, 1) })
      controlAxis.addComponent(RigidBody, { bodyDesc: RAPIER.RigidBodyDesc.dynamic() })
      controlAxis.addComponent(Collider, { colliderDesc: RAPIER.ColliderDesc.ball(0.7), collisionGroup: "ghost" })
      const jointDesc1 = RAPIER.JointData.revolute({ x: 0, y: 0, z: 0 }, { x: 0, y: 0, z: 0 }, { x: 0, y: 1, z: 0 })
      controlAxis.addComponent(Joint, { params: jointDesc1, body1: damper.getComponent(RigidBody), body2: controlAxis.getComponent(RigidBody) })


      this.scene.add(controlAxis, damper)

      const wheel = new GameObject(this, 'Wheel', { position: car.transform.position.clone().add(WheelPositions[i]), scale: new THREE.Vector3(1, 1, 1) })
      wheel.addComponent(MeshRenderer, { geometry: new THREE.CylinderGeometry(WheelRadius, WheelRadius, WheelRadius), material: new THREE.MeshStandardMaterial({ color: this.secondcolor }), renderTransform: new TransformData(new THREE.Vector3(0, 0, 0), new THREE.Euler(Math.PI / 2, 0, 0), new THREE.Vector3(1, 1, 1)) })
      const wheelColliderDesc = RAPIER.ColliderDesc.cylinder(WheelRadius / 2, WheelRadius)
      wheelColliderDesc.setRotation(new THREE.Quaternion().setFromAxisAngle(new THREE.Vector3(1, 0, 0), Math.PI / 2))
      wheelColliderDesc.setFriction(i >= 2 ? 1 : 1)
      wheelColliderDesc.setMass(10).setRestitution(0.0)
      wheel.addComponent(Collider, { colliderDesc: wheelColliderDesc, collisionGroup: "car" })
      wheel.addComponent(RigidBody, { bodyDesc: RAPIER.RigidBodyDesc.dynamic() })
      const jointDesc = RAPIER.JointData.revolute({ x: 0, y: 0, z: 0 }, { x: 0, y: 0, z: 0 }, { x: 0, y: 0, z: 1 })
      wheel.addComponent(Joint, { params: jointDesc, body1: controlAxis.getComponent(RigidBody), body2: wheel.getComponent(RigidBody) })

      this.scene.add(wheel, controlAxis)

      controlAxis.userData = { wheelId: i }

    }

    navigator.addProject(new ProjectPresentation(
      'Pickup',
      `
      Ce projet de pickup s'inscrit dans le cadre de mon portfolio interactif en 3D, entièrement développé sur le web.
      L'objectif était de créer une scène temps réel où chaque projet devient un objet interactif, plutôt qu'une simple page statique.

      Le portfolio repose sur une architecture WebGL basée sur Three.js, avec une structure ECS (Entity Component System) inspirée des moteurs de jeu.
      La physique est gérée avec Rapier, ce qui permet une simulation réaliste du véhicule (châssis, roues, contraintes physiques), tout en gardant de bonnes performances.

      Le pickup est composée de plusieurs RigidBodies reliés par des joints, avec une gestion fine des collisions pour éviter les interactions internes non désirées.
      L'interface (descriptions, projets, iframes) est rendue en HTML/CSS superposé à la scène 3D, ce qui permet d'intégrer facilement des projets externes (p5.js, Shadertoy, WebGL, etc.).</br><br>
      <h3>Controles :</h3><br>
      ZQSD / Flèches : déplacer le véhicule<br>
      Espace : freiner / Reculer<br>
      Clic gauche + souris : contrôler la caméra librement<br>

      `,
      '',
      car.getComponent(ControllerSpawner),
      '',
      carViewPoint.transform
    ))

    // TODO: add shadertoy projects
    const shadertoyIcon = new GameObject(this, 'Shadertoy', { position: new THREE.Vector3(-15, 5, 10), rotation: new THREE.Euler(0, Math.PI / 6, 0), scale: new THREE.Vector3(1, 1, 1).multiplyScalar(10) })
    shadertoyIcon.addComponent(MeshRenderer, { geometryPath: '/resources/models/shadertoy.obj' })
    this.scene.add(shadertoyIcon, floor)

    const shadertoyViewPoint = new GameObject(this, 'ShadertoyViewPoint', { position: new THREE.Vector3(0, 0, 2), rotation: new THREE.Euler(0, 0, 0) })
    shadertoyViewPoint.transform.lookAt(new THREE.Vector3(0, 0, 0))
    shadertoyViewPoint.transform.transformData = shadertoyViewPoint.transform.transformData.TransformLocalToWorld(shadertoyIcon.transform.transformData)
    this.scene.add(shadertoyViewPoint, shadertoyIcon)

    let shadertoyNavigator = shadertoyIcon.addComponent(ControllerSpawner, { controllerClass: ProjectNavigator, buildData: { name: "Shadertoy" } })
    let shadersJsonDatas: any;
    this.assetLoader.loadText('/src/game/ShadertoyIntegration/shadertoyCanvas.html')
    this.assetLoader.loadJson('/resources/documents/shaders_all.json').then((data) => {
      shadersJsonDatas = data
    })
    for (let path in cubemapPaths) {
      this.assetLoader.loadImage(cubemapPaths[path])
    }
    shadertoyNavigator.addBuildQueueListener((navigator) => {
      // load shaders data from json file
      for (let i = 0; i < shadersJsonDatas.shaders.length; i++) {
        (navigator as ProjectNavigator).addProject(new ProjectPresentation(shadersJsonDatas.shaders[i].info.name, shadersJsonDatas.shaders[i].info.description, "https://www.shadertoy.com/view/" + shadersJsonDatas.shaders[i].info.id, undefined, `
          <div style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0, 0, 0, 0); border-radius: 10px; pointer-events: auto">
            <span style="position: absolute; top: 75%; left: 50%; transform: translate(-50%, -50%); color: white; font-family: Arial, sans-serif; font-size: 48px;">En cours de chargement</span>
          </div>
        `, shadertoyViewPoint.transform).GenerateShadertoyOverlay(i, this))
      }

    })



    navigator.addProject(new ProjectPresentation('Shadertoy', "Des programmes de géneration d'image utilisant la carte graphique.<br>Cette section est en cours de construction<br><br>Voici le lien vers mon profil Shadertoy (on ne peut pas changer le pseudonyme et le compte est assez ancien.)", 'https://www.shadertoy.com/user/tacos_au_chili', shadertoyNavigator, `
      <div style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0, 0, 0, 0); border-radius: 10px; pointer-events: auto;border: yellow dashed 10px;">
        <span style="position: absolute; top: 75%; left: 50%; transform: translate(-50%, -50%); color: white; font-family: Arial, sans-serif; font-size: 48px;">En cours d'implementation</span>
      </div>

      `, shadertoyViewPoint.transform))

    // TODO: add C++/ DirectX / OpenGL projects
    const CppIcon = new GameObject(this, 'Cpp', { position: new THREE.Vector3(20, 5, 5), rotation: new THREE.Euler(0, -Math.PI / 6, 0), scale: new THREE.Vector3(1, 1, 1).multiplyScalar(3) })
    CppIcon.addComponent(TextRenderer3D, { text: 'C++' })
    this.scene.add(CppIcon, floor)
    const CppViewPoint = new GameObject(this, 'CppViewPoint', { position: new THREE.Vector3(1, 0.5, 4), rotation: new THREE.Euler(0, 0, 0) })
    CppViewPoint.transform.transformData = CppViewPoint.transform.transformData.TransformLocalToWorld(CppIcon.transform.transformData)
    this.scene.add(CppViewPoint, CppIcon)

    navigator.addProject(new ProjectPresentation('C++', "Des programmes en C++ notamment des débuts de moteurs graphiques en utilisant DirectX et OpenGL.<br>Cette section est en cours de construction", '', undefined, `
      <div style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0, 0, 0, 0); border-radius: 10px; pointer-events: auto;border: yellow dashed 10px;">
        <span style="position: absolute; top: 75%; left: 50%; transform: translate(-50%, -50%); color: white; font-family: Arial, sans-serif; font-size: 48px;">En cours d'implementation</span>
      </div>

      `, CppViewPoint.transform))

    this.start()
  }
  worldUpdate(_dt: number) {
    // set debug active if key tab is pressed
    if (this.input.onPress('KeyT')) this.scene.physicsDebug.enabled = !this.scene.physicsDebug.enabled

    // // set the fps counter
    // const fps = 1 / _dt
    // this.fps.userData.fpsBuffer = Math.min(this.fps.userData.fpsBuffer * 1.01 + 1, fps)
    // if (this.fps.getComponent(TextRenderer3D) !== undefined) this.fps.getComponent(TextRenderer3D)!.text = `fps: ${this.fps.userData.fpsBuffer.toFixed(0)}`

    // test if a transformData moved to lecal and return to world space changed
    //const randomTransformData = new TransformData(new THREE.Vector3(Math.random(), Math.random(), Math.random()), new THREE.Euler(Math.random(), Math.random(), Math.random()), new THREE.Vector3(Math.random(), Math.random(), Math.random()))
    //const randomTransformData2 = new TransformData(new THREE.Vector3(Math.random(), Math.random(), Math.random()), new THREE.Euler(Math.random(), Math.random(), Math.random()), new THREE.Vector3(Math.random(), Math.random(), Math.random()))
    //const result = randomTransformData.TransformWorldToLocal(randomTransformData2).TransformLocalToWorld(randomTransformData2)
    //if (!result.equals(randomTransformData)) console.log(result, randomTransformData)
  }
}
